import { createContext } from 'react';

import type { BlogPost } from 'components/molecules/JournalGroup';

export const MarketingPageContext = createContext<{
  internalBlogCostPosts?: Array<BlogPost>;
  internalBlogPosts: Array<BlogPost>;
}>({
  internalBlogCostPosts: [],
  internalBlogPosts: [],
});
